var passwordRuleCheckerInit = function (form) {
  $(form + " .validate-password-format").keyup(function () {
    var field = $(this);
    var passwordRules = $(form).validate().ruleValidationStatus(field);

    $.each(passwordRules, function (key, element) {
      var removeClass = element === true ? 'fa-times-circle' : 'fa-check-circle';
      var addClass = element === true ? 'fa-check-circle' : 'fa-times-circle';
      var fieldId = '';

      switch (key) {
        case 'minlength':
          fieldId = field.data('minlengthFieldId');
          break;
        case 'atLeastOneUppercaseLetter':
          fieldId = field.data('uppercaseFieldId');
          break;
        case 'atLeastOneSymbol':
          fieldId = field.data('oneSymbolId');
          break;
        default:
          return;
      }

      $(`#${fieldId}`).removeClass(removeClass).addClass(addClass);
    });
  })
}

// Commenting out - these are only required for FE testing.
// The linter is upset that the variables are defined and unused.
// var goToStepTwoInit = function (page) {
//   $(page + "_submit").click(function () {
//     if ($(page).valid()) {
//       $("#step-two-tab").tab("show");
//       $("#stepperOne, #stepperTwo").addClass("is-complete");
//     }
//   });
// }
// var goToVerifyInit = function (page) {
//   $(page + "_submit").click(function () {
//     if ($(page).valid()) {
//       $("#verify-tab").tab("show");
//       $("#stepperThree, #stepperFour").addClass("is-complete");
//     }
//   });
// }



$(document).ready(function () {
  $('.validator-form').validate({
    submitHandler: function(form) {
      form.submit();
    }
  });

  $('.validator-form').each(function (i, e) {
    passwordRuleCheckerInit(`#${e.id}`);
  });

 
  // Commenting out - these are only necessary for FE testing
  // goToStepTwoInit("#cardInfo")
  // goToVerifyInit("#createAccount")
  // goToStepTwoInit("#personalInfo")
  // goToVerifyInit("#accountInfo")
});
